<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 10rem;">
    <!-- Body -->
    <v-layout class="mb-12">
      <v-flex class="" style="position: relative">
        <div v-if="$vuetify.breakpoint.smAndUp">
          <!-- image Cover Profile -->
          <v-layout style="position: relative" class="mx-n12 mt-n4">
            <v-flex v-if="profile">
              <v-img
                :height="bio.length > 120 ? '450' : '380'"
                :src="
                  profile.mem_info
                    ? checkImage(profile.mem_info, 'cover_url')
                    : require('../../assets/cover.png')
                "
              ></v-img>
            </v-flex>
            <div
              style="width: 100%; height: 100%; background-color: rgba(0,0,0,0.5);position: absolute; top:0;"
            ></div>
          </v-layout>

          <!-- Header -->
          <!-- style="position: absolute; top: 0;left: 0;right:0" -->

          <v-layout
            style="position: absolute; top: 0;left: 0;right:0"
            class="mt-8 justify-center"
            v-if="profile"
          >
            <v-flex class="lg9 md10 sm10 xs10">
              <v-layout class="">
                <!-- Logo -->
                <v-flex class="shrink mr-6 on-hover">
                  <v-img
                    :src="
                      isHasImage()
                        ? url +
                          imgPath +
                          'images_profile/' +
                          profile.mem_info.avatar
                        : require('../../assets/user_profile.png')
                    "
                    height="60px"
                    width="60px"
                    style="border-radius: 100%"
                  />
                </v-flex>

                <!-- Detail Header  -->
                <v-flex class="lg8 md10 sm12">
                  <!-- Name  -->
                  <v-layout>
                    <v-flex
                      class="on-hover"
                      style="color: #fff;font-size: 20px"
                    >
                      <span>{{ checkName(profile) }}</span>
                    </v-flex>
                  </v-layout>

                  <!-- Bio  -->
                  <v-layout>
                    <v-flex
                      class="on-hover"
                      style="color: #fff;font-size: 14px"
                    >
                      {{ bio }}
                    </v-flex>
                  </v-layout>

                  <!-- Count portfolio -->
                  <v-layout>
                    <v-flex
                      class="on-hover"
                      style="color: #fff;font-size: 20px"
                    >
                      {{ $t("portfolio_profile") }} :
                      {{ number_portolio }}
                    </v-flex>
                  </v-layout>
                  <v-layout class="my-6">
                    <v-flex>
                      <v-divider style="border: 1px solid #F8F8F8;"></v-divider>
                    </v-flex>
                  </v-layout>

                  <!-- contact -->
                  <v-layout>
                    <v-flex>
                      <v-layout>
                        <v-flex
                          shrink
                          class="d-flex justify-center align-center"
                        >
                          <img
                            class="mr-2"
                            width="20"
                            :src="
                              require('../../assets/images/detail-portfolio/social/Path 1117@2x.png')
                            "
                            style="cursor: pointer"
                          />
                        </v-flex>
                        <v-flex
                          class="d-flex justify-start align-center"
                          style="color: #fff;font-size: 16px"
                        >
                          {{
                            profile.mobile_number ? profile.mobile_number : "-"
                          }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout class="mt-3">
                    <v-flex>
                      <v-layout>
                        <v-flex
                          shrink
                          class="d-flex justify-center align-center"
                        >
                          <img
                            class="mr-2"
                            width="20"
                            :src="
                              require('../../assets/images/detail-portfolio/social/Path 1116@2x.png')
                            "
                            style="cursor: pointer"
                          />
                        </v-flex>
                        <v-flex
                          class="d-flex justify-start align-center"
                          style="color: #fff;font-size: 16px"
                        >
                          {{ profile.email }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout class="mt-3">
                    <v-flex>
                      <v-layout>
                        <v-flex
                          shrink
                          class="d-flex justify-center align-center"
                        >
                          <img
                            class="mr-2"
                            width="20"
                            :src="
                              require('../../assets/images/detail-portfolio/social/Path 1115@2x.png')
                            "
                            style="cursor: pointer"
                          />
                        </v-flex>
                        <v-flex
                          class="d-flex justify-start align-center"
                          style="color: #fff;font-size: 16px"
                        >
                          {{
                            profile.mem_info && profile.mem_info.location
                              ? profile.mem_info.location
                              : "-"
                          }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout class="mt-6">
                    <v-flex
                      class="shrink mr-4"
                      @click="
                        openLink(
                          'https://www.instragram.com/',
                          profile.mem_info.instagram
                        )
                      "
                      v-if="profile.mem_info && profile.mem_info.instagram"
                    >
                      <v-img
                        width="30"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Group 666@2x.png')
                        "
                        style="cursor: pointer"
                      ></v-img>
                    </v-flex>

                    <v-flex
                      class="shrink mr-4"
                      v-if="profile.mem_info && profile.mem_info.facebook"
                      @click="
                        openLink(
                          'https://www.facebook.com/',
                          profile.mem_info.facebook
                        )
                      "
                    >
                      <v-img
                        width="30"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Group 665@2x.png')
                        "
                        style="cursor: pointer"
                      ></v-img>
                    </v-flex>

                    <!-- <v-flex
                    class="shrink"
                    v-if="profile.mem_info && profile.mem_info.pinterest"
                    @click="
                      openLink(
                        'https://www.pinterest.com/',
                        profile.mem_info.pinterest
                      )
                    "
                  >
                    <v-img
                      width="30"
                      :src="
                        require('../../assets/images/detail-portfolio/pinterest.png')
                      "
                      style="cursor: pointer"
                    ></v-img>
                  </v-flex> -->

                    <v-flex
                      class="shrink"
                      v-if="profile.mem_info && profile.mem_info.twitter"
                      @click="
                        openLink(
                          'https://www.twitter.com/',
                          profile.mem_info.twitter
                        )
                      "
                    >
                      <v-img
                        width="30"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Logo — FIXED@2x.png')
                        "
                        style="cursor: pointer"
                      ></v-img>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>

        <div v-else>
          <!-- image Cover Profile -->
          <v-layout style="position: relative" class="mt-n4">
            <v-flex v-if="profile">
              <v-img
                :height="bio.length > 150 ? '640' : '550'"
                :src="
                  profile.mem_info
                    ? checkImage(profile.mem_info, 'cover_url')
                    : require('../../assets/cover.png')
                "
              ></v-img>
            </v-flex>
            <div
              style="width: 100%; height: 100%; background-color: rgba(0,0,0,0.5);position: absolute; top:0;"
            ></div>
          </v-layout>

          <!-- Header -->
          <v-layout
            style="position: absolute; top: 0;left: 0;right:0"
            class="mt-8 justify-center pa-5"
            v-if="profile"
          >
            <v-flex>
              <!-- Logo -->
              <v-layout class="justify-center">
                <v-flex class="shrink on-hover">
                  <v-img
                    :src="
                      isHasImage()
                        ? url +
                          imgPath +
                          'images_profile/' +
                          profile.mem_info.avatar
                        : require('../../assets/user_profile.png')
                    "
                    height="80px"
                    width="80px"
                    style="border-radius: 100%"
                  />
                </v-flex>
              </v-layout>

              <!-- Detail Header  -->
              <v-layout class="justify-center mt-6">
                <v-flex class="text-center">
                  <!-- Name  -->
                  <v-layout class="justify-center mt-4">
                    <v-flex
                      class="on-hover"
                      style="color: #fff;font-size: 20px"
                    >
                      <span>{{ checkName(profile) }}</span>
                    </v-flex>
                  </v-layout>

                  <!-- Bio  -->
                  <v-layout v-show="bio" class="mt-4">
                    <v-flex
                      class="on-hover"
                      style="color: #fff;font-size: 14px"
                    >
                      <!-- {{
                      profile.mem_info.bio
                        ? profile.mem_info.bio.length > 200
                          ? profile.mem_info.bio.slice(0, 195) + "...."
                          : profile.mem_info.bio
                        : ""
                    }} -->
                      {{ bio }}
                    </v-flex>
                  </v-layout>

                  <!-- Count portfolio -->
                  <v-layout class="mt-4">
                    <v-flex
                      class="on-hover"
                      style="color: #fff;font-size: 20px"
                    >
                      {{ $t("portfolio_profile") }} :
                      {{ number_portolio }}
                    </v-flex>
                  </v-layout>

                  <!-- Socail -->
                  <v-layout class="mt-10 justify-center">
                    <v-flex
                      class="shrink mx-3"
                      @click="
                        openLink(
                          'https://www.instragram.com/',
                          profile.mem_info.instagram
                        )
                      "
                      v-if="profile.mem_info && profile.mem_info.instagram"
                    >
                      <v-img
                        width="30"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Group 666@2x.png')
                        "
                        style="cursor: pointer"
                      ></v-img>
                    </v-flex>

                    <v-flex
                      class="shrink mx-3"
                      v-if="profile.mem_info && profile.mem_info.facebook"
                      @click="
                        openLink(
                          'https://www.facebook.com/',
                          profile.mem_info.facebook
                        )
                      "
                    >
                      <v-img
                        width="30"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Group 665@2x.png')
                        "
                        style="cursor: pointer"
                      ></v-img>
                    </v-flex>

                    <!-- <v-flex
                    class="shrink"
                    v-if="profile.mem_info && profile.mem_info.pinterest"
                    @click="
                      openLink(
                        'https://www.pinterest.com/',
                        profile.mem_info.pinterest
                      )
                    "
                  >
                    <v-img
                      width="30"
                      :src="
                        require('../../assets/images/detail-portfolio/pinterest.png')
                      "
                      style="cursor: pointer"
                    ></v-img>
                  </v-flex> -->

                    <v-flex
                      class="shrink mx-3"
                      v-if="profile.mem_info && profile.mem_info.twitter"
                      @click="
                        openLink(
                          'https://www.twitter.com/',
                          profile.mem_info.twitter
                        )
                      "
                    >
                      <v-img
                        width="30"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Logo — FIXED@2x.png')
                        "
                        style="cursor: pointer"
                      ></v-img>
                    </v-flex>
                  </v-layout>

                  <!-- contact phone -->
                  <v-layout class="mt-12">
                    <v-flex shrink class="d-flex justify-center align-center">
                      <img
                        class="mr-2"
                        width="20"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Path 1117@2x.png')
                        "
                        style="cursor: pointer"
                      />
                    </v-flex>
                    <v-flex
                      class="d-flex justify-start align-center"
                      style="color: #fff;font-size: 16px"
                    >
                      {{ profile.mobile_number ? profile.mobile_number : "-" }}
                    </v-flex>
                  </v-layout>

                  <!-- contact email -->
                  <v-layout class="mt-3">
                    <v-flex>
                      <v-layout>
                        <v-flex
                          shrink
                          class="d-flex justify-center align-center"
                        >
                          <img
                            class="mr-2"
                            width="20"
                            :src="
                              require('../../assets/images/detail-portfolio/social/Path 1116@2x.png')
                            "
                            style="cursor: pointer"
                          />
                        </v-flex>
                        <v-flex
                          class="d-flex justify-start align-center"
                          style="color: #fff;font-size: 16px"
                        >
                          {{ profile.email }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- contact location -->
                  <v-layout class="mt-3">
                    <v-flex shrink class="d-flex justify-center align-center">
                      <img
                        class="mr-2"
                        width="20"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Path 1115@2x.png')
                        "
                        style="cursor: pointer"
                      />
                    </v-flex>
                    <v-flex
                      class="text-start ow pr-10"
                      style="color: #fff;font-size: 16px"
                    >
                      {{
                        profile.mem_info && profile.mem_info.location
                          ? profile.mem_info.location
                          : "-"
                      }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>

        <!-- Detail -->
        <v-layout class="justify-center my-8">
          <v-flex lg9 md10 sm10 xs11>
            <v-layout class="justify-center mt-6">
              <v-flex
                class="text-center font-weight-bold"
                style="font-size: 24px"
              >
                <span>{{ project_title }}</span>
              </v-flex>
            </v-layout>
            <v-layout class="justify-center mt-6">
              <v-flex
                class="text-center"
                v-if="project_brief !== 'NULL'"
                style="font-size: 18px"
              >
                <span>{{ project_brief }}</span>
              </v-flex>
            </v-layout>
            <v-layout class="justify-center mt-6">
              <v-flex class="text-center" style="font-size: 16px">
                <span style="color: #FD5246;"
                  >{{ $t("last-update") }} :
                  {{ updated_at | moment("DD/MM/YYYY") }}</span
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Card Group -->
        <v-layout class="justify-center">
          <v-flex lg9 md10 sm10 xs11>
            <!-- Desktop -->
            <v-layout v-if="$vuetify.breakpoint.smAndUp" mb-6>
              <v-flex shrink mr-2 v-show="portfolio_cate">
                <v-btn :color="checkBtnColor(portfolio_cate.id)">
                  <!-- <v-icon color="#fff"
                    >{{ portfolio_cate ? portfolio_cate.icon : "more_horiz" }}
                  </v-icon> -->
                  <v-img
                    lazy-src=""
                    :width="portfolio_cate.id == 0 ? '20' : '35'"
                    :src="checkIcon(portfolio_cate.name_en)"
                  ></v-img>
                  <span v-if="portfolio_cate" style="color: #FFFFFF">{{
                    switchLanguage === "th"
                      ? portfolio_cate.name_th
                      : portfolio_cate.name_en
                  }}</span>
                </v-btn>
              </v-flex>
              <v-flex shrink v-show="portfolio_sub_cate">
                <v-btn outlined :color="checkBtnColor(portfolio_cate.id)">
                  <span :style="{ color: checkBtnColor(portfolio_cate.id) }">
                    {{
                      portfolio_sub_cate
                        ? switchLanguage === "th"
                          ? portfolio_sub_cate.name_th
                          : portfolio_sub_cate.name_en
                        : ""
                    }}
                  </span>
                </v-btn>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex shrink mr-4 class="d-flex align-center">
                <v-icon class="mr-2">remove_red_eye</v-icon>
                <span>{{ view }}</span>
              </v-flex>

              <!-- Share Facebook -->
              <v-flex mr-3 shrink>
                <v-btn depressed color="#4365FF">
                  <v-icon color="#fff" class="mr-2">share</v-icon>
                  <i
                    style="color: #fff; font-size: 25px"
                    class="fab fa-facebook"
                  ></i>
                </v-btn>
              </v-flex>
              <!-- Share Twitter -->
              <v-flex shrink>
                <v-btn depressed color="#49B1FF">
                  <v-icon color="#fff" class="mr-2">share</v-icon>
                  <i
                    style="color: #fff; font-size: 25px"
                    class="fab fa-twitter-square"
                  ></i>
                </v-btn>
              </v-flex>
            </v-layout>

            <!-- Mobile -->
            <v-layout v-else wrap>
              <v-flex>
                <v-layout justify-space-between wrap>
                  <v-flex shrink pr-3 mb-3>
                    <v-btn :color="checkBtnColor(portfolio_cate.id)">
                      <v-icon color="#fff"
                        >{{
                          portfolio_cate ? portfolio_cate.icon : "more_horiz"
                        }}
                      </v-icon>
                      <span v-if="portfolio_cate" style="color: #FFFFFF">{{
                        switchLanguage === "th"
                          ? portfolio_cate.name_th
                          : portfolio_cate.name_en
                      }}</span>
                    </v-btn>
                  </v-flex>
                  <v-flex shrink class="text-end" v-if="portfolio_sub_cate">
                    <v-btn outlined :color="checkBtnColor(portfolio_cate.id)">
                      <span
                        :style="{ color: checkBtnColor(portfolio_cate.id) }"
                      >
                        {{
                          portfolio_sub_cate
                            ? switchLanguage === "th"
                              ? portfolio_sub_cate.name_th
                              : portfolio_sub_cate.name_en
                            : ""
                        }}
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout class="mt-6 d-flex align-center">
                  <v-flex shrink class="text-start mr-6">
                    <v-icon class="mr-2">remove_red_eye</v-icon>
                    <span>{{ view }}</span>
                  </v-flex>
                  <v-flex mr-3 shrink>
                    <v-btn color="#4365FF">
                      <v-icon color="#fff" class="mr-2">share</v-icon>
                      <i
                        style="color: #fff; font-size: 20px"
                        class="fab fa-facebook"
                      ></i>
                    </v-btn>
                  </v-flex>
                  <v-flex shrink>
                    <v-btn color="#49B1FF">
                      <v-icon color="#fff" class="mr-2">share</v-icon>
                      <i
                        style="color: #fff; font-size: 20px"
                        class="fab fa-twitter-square"
                      ></i>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout class="my-12" v-if="data.detail">
              <v-flex class="v-html" v-html="data.detail"> </v-flex>
            </v-layout>

            <!-- Card -->
            <v-layout class="mt-12">
              <v-flex>
                <v-card
                  style="background-color: #F8F8F8"
                  flat
                  class="pb-6"
                  v-for="(portfolio, i) in portfolios"
                  :key="i"
                >
                  <v-layout class="justify-space-around" wrap>
                    <v-flex xs12 class="text-center" style="max-width: 1280px">
                      <div>
                        <img
                          style="object-fit: contain;cursor: pointer"
                          @click="
                            onPreview(url + imgPath + 'images/' + portfolio.img)
                          "
                          :src="
                            portfolio.img
                              ? url + imgPath + 'images/' + portfolio.img
                              : require('../../assets/tcdc-color.png')
                          "
                          width="100%"
                        />
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout class="mt-2">
                    <v-flex class="text-center">
                      <span>
                        {{ portfolio.detail ? portfolio.detail : "" }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Tags -->
        <div v-if="tags.length > 0">
          <v-layout class="justify-center">
            <v-flex class="lg9 md10 sm10 xs11 py-sm-12 py-3">
              <v-layout wrap class="d-flex align-center">
                <v-flex class="shrink">
                  <span>Tag : </span>
                </v-flex>
                <v-flex
                  style="font-weight: bold;"
                  class="my-1 mx-1"
                  shrink
                  v-for="tag in tags"
                  :key="tag.id"
                >
                  <v-btn outlined color="#EF3E2D">
                    {{ tag.name }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>

        <v-layout class="justify-center mt-12 mb-14">
          <v-flex class="lg12 md10 sm10 xs11">
            <v-divider style="border: 0.5px solid #C4C4C4;"></v-divider>
          </v-flex>
        </v-layout>

        <!-- Other Title -->
        <v-layout class="justify-center my-6" v-if="slideLists.length > 0">
          <v-flex shrink class="text-center mx-4">
            <v-layout>
              <v-flex>
                <span style="font-size: 18px;font-weight: bold;color: #424242">
                  OTHER
                </span>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <span style="color: #FD5246;">แฟ้มผลงานอื่นๆ</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- Other Portfolio -->
        <v-layout class="justify-space-around" v-if="slideLists.length > 0">
          <v-flex lg12 md11 sm12 xs12>
            <!-- Desktop size -->
            <v-layout justify-center wrap v-if="$vuetify.breakpoint.smAndUp">
              <v-flex
                class="xs2 pa-2"
                v-for="(slideList, i) in slideLists.slice(0, 6)"
                :key="i"
              >
                <v-hover
                  v-slot:default="{ hover }"
                  open-delay="50"
                  style="cursor: pointer;background-color: white"
                >
                  <v-card flat @click.native="viewPortDetail(slideList)">
                    <v-layout>
                      <v-flex>
                        <v-img
                          :src="
                            slideList.img_cover
                              ? url +
                                imgPath +
                                'images_cover/' +
                                slideList.img_cover
                              : require('../../assets/tcdc-color.png')
                          "
                          class="img-content-cover"
                          aspect-ratio="1"
                          :contain="slideList.img_cover ? false : true"
                        >
                          <v-expand-transition>
                            <div
                              v-if="hover"
                              class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                              style="height: 100%;"
                            >
                              <span
                                style="font-size: 16px;font-weight: bold"
                                class="text-uppercase"
                                >see detail</span
                              >
                            </div>
                          </v-expand-transition>
                        </v-img>
                      </v-flex>
                    </v-layout>

                    <v-layout
                      class="pa-4 layout-slide-button d-flex align-center"
                      style="background-color: #fff"
                    >
                      <v-flex class="shrink mr-2">
                        <v-img
                          :src="
                            slideList.img_content_by
                              ? url +
                                imgPath +
                                'images_profile/' +
                                slideList.img_content_by
                              : require('../../assets/user_profile.png')
                          "
                          :height="
                            $vuetify.breakpoint.smAndUp ? '25px' : '35px'
                          "
                          :width="$vuetify.breakpoint.smAndUp ? '25px' : '35px'"
                          style="border-radius: 100%"
                        />
                      </v-flex>
                      <v-flex>
                        <div
                          style="font-weight: bold;font-size: 14px"
                          class="ellipsis-other"
                        >
                          <span v-if="$vuetify.breakpoint.mdAndUp">
                            {{ slideList.name_content }}
                          </span>
                        </div>
                        <div class="ellipsis-other" style="font-size: 10px">
                          {{ $t("by") }} {{ slideList.content_by }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-hover>
              </v-flex>
            </v-layout>

            <!-- Mobile size -->
            <v-layout wrap v-else>
              <v-flex>
                <v-sheet
                  :style="
                    $vuetify.breakpoint.smAndUp
                      ? 'background-color: #F8F8F8; padding-left: 30px; padding-right: 30px;'
                      : 'background-color: #F8F8F8;'
                  "
                >
                  <v-slide-group
                    v-model="model"
                    class="pa-2"
                    center-active
                    show-arrows
                  >
                    <v-slide-item v-for="(slideList, i) in slideLists" :key="i">
                      <v-hover
                        v-slot:default="{ hover }"
                        open-delay="50"
                        style="cursor: pointer;background-color: white"
                      >
                        <v-card
                          flat
                          class="mx-4"
                          @click.native="viewPortDetail(slideList)"
                        >
                          <v-layout>
                            <v-flex>
                              <v-img
                                :height="
                                  $vuetify.breakpoint.lgAndUp
                                    ? 230
                                    : '' || $vuetify.breakpoint.mdAndUp
                                    ? 200
                                    : '' || $vuetify.breakpoint.smAndUp
                                    ? 185
                                    : '' || $vuetify.breakpoint.smAndDown
                                    ? 280
                                    : ''
                                "
                                :src="
                                  slideList.img_cover
                                    ? url +
                                      imgPath +
                                      'images_cover/' +
                                      slideList.img_cover
                                    : require('../../assets/tcdc-color.png')
                                "
                                class="img-content-cover"
                                aspect-ratio="1"
                                :contain="slideList.img_cover ? false : true"
                              >
                                <v-expand-transition>
                                  <div
                                    v-if="hover"
                                    class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                                    style="height: 100%;"
                                  >
                                    <span
                                      style="font-size: 16px;font-weight: bold"
                                      class="text-uppercase"
                                      >see detail</span
                                    >
                                  </div>
                                </v-expand-transition>
                              </v-img>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            class="pa-4 layout-slide-button d-flex align-center"
                            style="background-color: #fff"
                          >
                            <v-flex class="shrink mr-2">
                              <v-img
                                :src="
                                  slideList.img_content_by
                                    ? url +
                                      imgPath +
                                      'images_profile/' +
                                      slideList.img_content_by
                                    : require('../../assets/user_profile.png')
                                "
                                :height="
                                  $vuetify.breakpoint.smAndUp ? '25px' : '35px'
                                "
                                :width="
                                  $vuetify.breakpoint.smAndUp ? '25px' : '35px'
                                "
                                style="border-radius: 100%"
                              />
                            </v-flex>
                            <v-flex>
                              <div
                                :style="{
                                  'font-size': $vuetify.breakpoint.lgAndUp
                                    ? '13px'
                                    : '' || $vuetify.breakpoint.mdAndUp
                                    ? '12px'
                                    : '' || $vuetify.breakpoint.smAndUp
                                    ? '10px'
                                    : '' || $vuetify.breakpoint.smAndDown
                                    ? '13px'
                                    : '',
                                }"
                                style="font-weight: bold;"
                              >
                                <span v-if="$vuetify.breakpoint.mdAndUp">{{
                                  slideList.name_content.length > 30
                                    ? slideList.name_content.slice(0, 25) +
                                      ". . . ."
                                    : slideList.name_content
                                }}</span>
                                <span v-else-if="$vuetify.breakpoint.smAndUp">{{
                                  slideList.name_content.length > 25
                                    ? slideList.name_content.slice(0, 20) +
                                      ". . . ."
                                    : slideList.name_content
                                }}</span>
                                <span v-else>{{
                                  slideList.name_content.length > 35
                                    ? slideList.name_content.slice(0, 30) +
                                      ". . . ."
                                    : slideList.name_content
                                }}</span>
                              </div>
                              <div
                                :style="{
                                  'font-size': $vuetify.breakpoint.lgAndUp
                                    ? '13px'
                                    : '' || $vuetify.breakpoint.mdAndUp
                                    ? '12px'
                                    : '' || $vuetify.breakpoint.smAndUp
                                    ? '10px'
                                    : '' || $vuetify.breakpoint.smAndDown
                                    ? '13px'
                                    : '',
                                }"
                              >
                                {{ $t("by") }} {{ slideList.content_by }}
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-hover>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout justify-center>
          <v-flex xs12>
            <v-dialog v-model="Modal" :width="width">
              <v-card>
                <v-img :src="image_preview"></v-img>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </v-content>
</template>

<script>
import { domain, imgPath, domainFrontend } from "../../services/Constants";
import CardContent from "../../components/card_content/CardContent";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Service from "../../services/Service";

export default {
  name: "DetailPortfolio",
  components: {
    Loading,
    CardContent,
  },
  data: () => ({
    text:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto in error quod laudantium debitis deserunt ipsum eum, dicta ratione. Eaque eos impedit corrupti repudiandae adipisci pariatur dolor doloribus! Voluptatem, labore!",
    width: "75%",
    image_preview: null,
    Modal: false,
    domain_frontend: domainFrontend,
    isLoading: false,
    fullPage: true,
    model: null,
    carousel: 0,
    portfolios: [],
    tags: [],
    slideLists: [],
    imgPath: imgPath,
    url: domain,
    cover_img_path: "",
    project_brief: "",
    project_title: "",
    updated_at: "",
    number_portolio: 0,
    profile: [],
    portfolio_cate: [],
    portfolio_sub_cate: [],
    view: null,
    data: [],
    portfolio_id: "",
    bio: "",
    port_id: "",
  }),
  computed: {
    ...mapState({
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
      category_id: (state) => {
        return state.portfolio.portfolio_categorys.category_id;
      },
      image_profile_facebook: (state) => {
        return state.auth.image_profile_facebook;
      },
      user: (state) => {
        return state.auth.users;
      },
    }),
    urlShareFacebook() {
      return `${this.url}api/share-facebook/${this.port_id}`;
    },
    urlShareTwitter() {
      return `${this.url}api/share-twitter/${this.port_id}`;
    },
  },
  async created() {
    console.log(this.user);
    console.log(this.$route.params.domain_slug);
    console.log(this.user.mem_info.domain_name);
    console.log(
      this.user &&
        this.user.mem_info &&
        this.user.mem_info.domain_name == this.$route.params.domain_slug
    );
    if (
      this.user &&
      this.user.mem_info &&
      this.user.mem_info.domain_name == this.$route.params.domain_slug
    ) {
      this.port_id = this.$route.params.portfolio_id_slug;
      this.isLoading = true;
      await Promise.all([
        // this.saveViewport(this.$route.params.portfolio_id_slug),
        this.previewPortfolioDetailByMemberId(
          this.$route.params.portfolio_id_slug
        ),
        this.getOrtherPortfolios(
          this.$route.params.portfolio_id_slug,
          this.$route.params.domain_slug
        ),
      ])
        .then(() => {
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    } else {
      this.$swal({
        icon: "error",
        title: "ไม่สามารถดู preview ได้",
        confirmButtonColor: "#FD5246",
        confirmButtonText: "ตกลง",
      }).then(() => {
        this.$router.push("/homepage");
      });
    }
  },
  methods: {
    onPreview(img) {
      this.image_preview = img;
      this.Modal = true;
    },
    saveViewport(id) {
      return this.$store.dispatch("portfolio/saveView", id).catch((e) => {
        this.isLoading = false;
      });
    },
    previewPortfolioDetailByMemberId(id) {
      return this.$store
        .dispatch("portfolio/previewPortfolioDetailByMemberId", {
          id: id,
          profile_id: this.user.profile_id,
        })
        .then((res) => {
          this.data = res.data;
          this.portfolios = [];
          this.portfolio_id = res.data.portfolio_id;
          this.profile = res.data.profile;
          if (res.data.profile.mem_info) {
            this.bio = res.data.profile.mem_info.bio
              ? res.data.profile.mem_info.bio.length > 200
                ? res.data.profile.mem_info.bio.slice(0, 150) + "...."
                : res.data.profile.mem_info.bio
              : "";
          }
          this.number_portolio = res.data.portfolio_member;
          this.cover_img_path = res.data.cover_img_path;
          this.project_brief = res.data.project_brief;
          this.project_title = res.data.project_title;
          this.updated_at = res.data.updated_at;
          this.portfolio_cate = res.data.portfolio_cate;
          this.portfolio_sub_cate = res.data.portfolio_sub_cate;
          this.view = res.data.view;
          res.data.portfolio_image.forEach((data) => {
            this.portfolios.push({
              detail: data.detail ? data.detail : "",
              img: data.img_path,
            });
          });
          this.tags = [];
          res.data.tag_port.forEach((data) => {
            this.tags.push({
              id: data.tag.id,
              name: data.tag.name,
            });
          });
          this.isLoading = false;
        })
        .then(() => {
          $("img").each(function() {
            var image = $(this);
            if (
              image.context.naturalWidth == 0 ||
              image.readyState == "uninitialized"
            ) {
              // if(image.height() <= 30){
              $(image)
                .unbind("error")
                .hide();
            }
          });
          setTimeout(() => {
            $("img").each(function() {
              var image = $(this);
              if (image.context.naturalWidth) {
                // if(image.height() <= 30){
                $(image)
                  .unbind("error")
                  .show();
              }
            });
          }, 1000);
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    openSocial(val) {
      switch (val) {
        case "facebook":
          this.profile
            ? this.profile.facebook
              ? window.open("https://www.facebook.com/" + this.profile.facebook)
              : ""
            : "";
          break;
        case "instagram":
          this.profile
            ? this.profile.instagram
              ? window.open(
                  "https://www.instagram.com/" + this.profile.instagram
                )
              : ""
            : "";
          break;
        case "twitter":
          this.profile
            ? this.profile.pinterest
              ? window.open(
                  "https://www.pinterest.com/" + this.profile.pinterest
                )
              : ""
            : "";
          break;
      }
    },
    onClickTag(val) {
      const data = {
        page: 1,
        id: val.id,
      };
      this.isLoading = true;
      this.$store
        .dispatch("portfolio/getPortfolioByIdTag", data)
        .then((res) => {
          this.isLoading = false;
          this.$router.push({
            path: "/portfolio-tag",
            query: { tag: val.name },
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    onclickCategory() {
      this.$router
        .push(
          `/portfolio-category/${
            this.switchLanguage === "th"
              ? this.portfolio_cate.name_th
              : this.portfolio_cate.name_en
          }${
            this.portfolio_cate.name_th === "รวม"
              ? ""
              : "-" + this.portfolio_cate.id
          }`
        )
        .catch(() => {});

      // todo
      // let data = {
      //   id: this.portfolio_cate.id,
      //   page: 1,
      // };
      // this.$store
      //   .dispatch("portfolio/getPortfolioByIdCategory", data)
      //   .then((res) => {
      //     this.isLoading = false;
      //     if (this.currentRouteName !== "AllPortfolioByCategory") {
      //       this.$router.push(`/portfolio-category`);
      //     }
      //   })
      //   .catch((e) => {
      //     this.isLoading = false;
      //   });
    },
    onClickSubCate() {
      this.$router
        .push(
          `/portfolio-category/${
            this.switchLanguage === "th"
              ? this.portfolio_cate.name_th
              : this.portfolio_cate.name_en
          }${
            this.portfolio_cate.name_th === "รวม"
              ? ""
              : "-" + this.portfolio_cate.id
          }?sc=${this.portfolio_sub_cate.id}`
        )
        .catch(() => {});

      // todo
      // let data = {
      //   category_id: parseInt(this.portfolio_sub_cate.category_id),
      //   subcategory_id: this.portfolio_sub_cate.id,
      // };
      // this.isLoading = true;
      // this.$store
      //   .dispatch("portfolio/getPortfolioByIdSubCategory", data)
      //   .then(() => {
      //     this.isLoading = false;
      //     this.$router
      //       .push(
      //         `/portfolio-category/${
      //           this.switchLanguage === "th"
      //             ? this.portfolio_cate.name_th
      //             : this.portfolio_cate.name_en
      //         }${
      //           this.portfolio_cate.name_th === "รวม"
      //             ? ""
      //             : "-" + this.portfolio_cate.id
      //         }?sc=${this.portfolio_sub_cate.id}`
      //       )
      //       .catch(() => {});
      //   })
      //   .catch((e) => {
      //     this.isLoading = false;
      //   });
    },
    hastag() {
      return this.tags.map((tag) => tag.name).join(",");
    },
    share(val) {
      switch (val) {
        case "facebook":
          Service.post("api/share-social", {
            socialName: val,
            portfolio_id: this.$route.params.portfolio_id_slug,
          });
          document.getElementById("share-facebook").click();
          break;
        case "twitter":
          Service.post("api/share-social", {
            socialName: val,
            portfolio_id: this.$route.params.portfolio_id_slug,
          });
          document.getElementById("share-twitter").click();
          break;
      }
    },
    goToDesigner() {
      this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
      this.$router.push({
        path: `/profile/${this.$route.params.domain_slug}`,
      });
    },
    getOrtherPortfolios(portfolio_id, profile_id) {
      return this.$store
        .dispatch("portfolio/getOrtherPortfolios", {
          profile_id: profile_id,
          portfolio_id: portfolio_id,
        })
        .then((res) => {
          this.slideLists = [];
          res.forEach((data) => {
            this.slideLists.push({
              portfolio_id: data.portfolio_id,
              name_content: data.project_title,
              profile_id: data.profile.profile_id,
              content_by: this.checkName(data.profile),
              img_cover: data.cover_img_path,
              img_content_by: data.profile.mem_info.avatar,
              domain_slug:
                data.profile.mem_info && data.profile.mem_info.domain_name
                  ? data.profile.mem_info.domain_name
                  : data.profile.profile_id,
            });
          });
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    viewPortDetail(val) {
      this.isLoading = true;
      // this.$router.replace({
      //   path: val.domain_slug,
      //   query: { id: val.portfolio_id, pfid: val.profile_id },
      // });
      this.$router.replace({
        // path: `/${val.domain_slug}/${val.profile_id}/${val.portfolio_id}`,
        path: `/profile/${val.domain_slug}/${val.portfolio_id}`,
      });

      this.previewPortfolioDetailByMemberId(val.portfolio_id);
      this.getOrtherPortfolios(val.portfolio_id, val.domain_slug);
    },
    isHasImage() {
      if (
        this.profile &&
        this.profile.mem_info &&
        this.profile.mem_info.avatar
      ) {
        return true;
      }
      return false;
    },
    isHasWorkPlace() {
      if (
        this.profile &&
        this.profile.mem_info &&
        this.profile.mem_info.location
      ) {
        return true;
      }
      return false;
    },
    openLink(text, link) {
      window.open(text + link, "_blank");
    },
    checkImage(val, type) {
      switch (type) {
        case "avatar":
          if (val.avatar) {
            return this.url + this.imgPath + "images_profile/" + val.avatar;
          } else {
            if (this.image_profile_facebook) {
              return this.image_profile_facebook;
            } else {
              require("../../assets/user_profile.png");
            }
          }
          break;

        case "cover_url":
          return val.cover_url
            ? this.url + this.imgPath + "images_profile_cover/" + val.cover_url
            : require("../../assets/cover.png");
          break;
      }
    },
    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 15) {
          return val.name_th.length > 20
            ? val.name_th.slice(0, 15) + " . . . . "
            : val.name_th;
        } else {
          return (
            val.name_th +
            " " +
            (val.last_th.length > 25
              ? val.last_th.slice(0, 20) + " . . . . "
              : val.last_th)
          );
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 15) {
          return val.name_en.length > 20
            ? val.name_en.slice(0, 15) + " . . . . "
            : val.name_en;
        } else {
          return (
            val.name_en +
            " " +
            (val.last_en.length > 25
              ? val.last_en.slice(0, 20) + " . . . . "
              : val.last_en)
          );
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
    checkIcon(iconName) {
      switch (iconName) {
        case "Design":
          return require("../../assets/icons/whiteIcon/การออกแบบ@2x.png");
        case "Architecture":
          return require("../../assets/icons/whiteIcon/สถาปัตยกรรม@2x.png");
        case "Fashion":
          return require("../../assets/icons/whiteIcon/แฟชั่น@2x.png");
        case "Craft":
          return require("../../assets/icons/whiteIcon/งานฝีมือ@2x.png");
        case "Advertising":
          return require("../../assets/icons/whiteIcon/การโฆษณา@2x.png");
        case "Visual Arts":
          return require("../../assets/icons/whiteIcon/ทัศนศิลป์@2x.png");
        case "Food":
          return require("../../assets/icons/whiteIcon/อาหารไทย@2x.png");
        case "Cultural and Heritage Tourism":
          return require("../../assets/icons/whiteIcon/การท่องเที่ยวเชิงวัฒนธรรม@2x.png");
        case "Film":
          return require("../../assets/icons/whiteIcon/ภาพยนต์@2x.png");
        case "Publishing":
          return require("../../assets/icons/whiteIcon/การพิมพ์@2x.png");
        case "Software":
          return require("../../assets/icons/whiteIcon/ซอฟแวร์@2x.png");
        case "Music":
          return require("../../assets/icons/whiteIcon/ดนตรี@2x.png");
        case "Performing Arts":
          return require("../../assets/icons/whiteIcon/ศิลปะการแสดง@2x.png");
        case "Broadcasting":
          return require("../../assets/icons/whiteIcon/การแพร่ภาพและกระจายเสียง@2x.png");
        case "Thai Traditional Medicine":
          return require("../../assets/icons/whiteIcon/การแพทย์แผนไทย@2x.png");
        default:
          return require("../../assets/icons/whiteIcon/ทั้งหมด@2x.png");
      }
    },
    checkBtnColor(cateId) {
      switch (cateId) {
        case "0":
          return "#ef3e2e";
        case "10":
          return "#74bf92";
        case "11":
          return "#ac9277";
        case "12":
          return "#c98074";
        case "1":
          return "#957722";
        case "9":
          return "#e19705";
        case "4":
          return "#4cc2d2";
        case "13":
          return "#e47645";
        case "115":
          return "#8a233d";
        case "5":
          return "#cd4646";
        case "7":
          return "#92b4cb";
        case "8":
          return "#9f939a";
        case "2":
          return "#733c90";
        case "3":
          return "#684c41";
        case "6":
          return "#3b5fa6";
        case "14":
          return "#28645e";
        default:
          return "#ef3e2e";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ellipsis-other {
  max-width: calc(100% - 25px);
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.on-hover:hover {
  color: #fd5246;
  cursor: pointer;
}

.v-html {
  /deep/ img {
    max-width: 100%;
    height: auto;
  }

  /deep/ iframe {
    width: 100%;
    height: 600px;
  }
}

.ow {
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

@media only screen and (max-width: 600px) {
  .v-html {
    /deep/ img {
      width: 100%;
      height: auto;
    }

    /deep/ iframe {
      width: 100%;
      height: 250px;
    }
  }
}
.bg-heroes {
  position: relative;
  background-image: url("../../assets/cover.png");
  opacity: 2;
  background-size: cover;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
</style>
